import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { AgileFileDownloadRequest } from './model/agile-file-download-request';
import { AgileFileInfo } from './model/agile-file-info';
import { DownloadStatusModel } from './model/download-status-model';
import { FileTypeCodeInfo } from './model/file-type-code-info.model';
import { UploadStatusModel } from './model/upload-status-model';
import { URLParams } from './model/urlparams';
import { UserPrivilegeInfo } from './model/user-privilege-info';
import { UserSessionInfo } from './model/user-session-info';
import { AgileSDKService } from './services/agile-sdk.service';
import { PartAttachmentInfo } from './model/part-attachment-info';
import { HardwareRelationshipMappingInfo } from './model/agile-file-upload-response';
import { TransferFilesRequestModel } from './model/transfer-files-request-model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {


  loadBalanced:boolean = environment.loadBalanced;
  isLoading: boolean = true;
  loadingMessage: string = 'Checking Privileges. Please wait...'
  userSessionInfo: UserSessionInfo;
  uploadFileInfo: AgileFileInfo[] = [];
  fileTypeCodeRes: FileTypeCodeInfo[] = [];
  fileExtension: string[];

  downloadFilesInfo: DownloadStatusModel[] = [];


  //GE2
  servers:string[] = environment.servers;

  //prod
  // servers:string[] = ['AUSPWAGLSSL04.aus.amer.dell.com','AUSPWAGLSSL06.aus.amer.dell.com'];

  //get filetype code
  //set filetypecode

  agileFileDownloadReqs: AgileFileDownloadRequest;

  userPrivilegeInfo: UserPrivilegeInfo = {
    hasAccessToItem: false,
    hasUploadPrivilege: false,
    hasDownloadPrivilege: false,
    hasReplacePrivilege: false,
    hasDeletePrivilege: false,
    hasOSLangPrivilege: false,
  };


  urlParams: URLParams = new URLParams();

  toggleValue: boolean = true;
  fcConnectionKey: string;
  uploadFiles: UploadStatusModel[] = [];
  transferRequests:TransferFilesRequestModel[] = [];

  hardwareRelationshipInfo:HardwareRelationshipMappingInfo;

  partAttachments: PartAttachmentInfo[] = [];

  constructor(private agileService: AgileSDKService) { }

  filesToUpload: string[] = [];
  
  uploadPGPMessage: string = '';
  downloadPGPMessage: string = '';

  queryDetails: object = { agileClassID: '', agile_1001: '', agile_1014: '', agileUserName: '', contextType: '', contextName: '' }

  setQueryParams(params: ParamMap) {


    console.log('params ', params)

    this.queryDetails['agileClassID'] = params.get('agile.classID');
    this.queryDetails['agile_1001'] = params.get('agile.1001');
    this.queryDetails['agile_1014'] = params.get('agile.1014');
    this.queryDetails['agileUserName'] = params.get('agile.userName');
    this.queryDetails['contextType'] = params.get('ContextType');
    this.queryDetails['contextName'] = params.get('ContextName');


      this.urlParams.userName = params.get('agile.userName');
      this.urlParams.partClass = params.get('ContextType');
      this.urlParams.partNumber = params.get('ContextName');
      this.urlParams.partRevision = params.get('agile.1014').split(' ')[0];
      this.urlParams.changeNumber = params.get('agile.1014').substring(params.get('agile.1014').lastIndexOf(' ')+1).trim();

      // this.urlParams.skipFCRemoteList = params.get('skiplist');
      // this.urlParams.status = 'locked';




    console.log('Item Details ', this.queryDetails)
    console.log('Query Params ',this.urlParams)

  }

  getQueryParams() {
    return this.queryDetails;
  }

  getUrlParams() {
    return this.urlParams;
  }

  setLoadingMessage(message: string) {
    this.loadingMessage = message;
  }

  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  getIsLoading() {
    return this.isLoading;
  }

  setUserSessionInfo(userSessionInfo) {
    console.log('Data Service :: setting user session info ', userSessionInfo)
    this.userSessionInfo = userSessionInfo;
  }
  getUserSessionInfo() {
    console.log('Data Service :: sending user session info ', this.userSessionInfo)
    return this.userSessionInfo;
  }

  setUserPrivilegeInfo(userPrivilegeInfo) {
    console.log('Data Service :: setting user privilege info ', userPrivilegeInfo)
    this.userPrivilegeInfo = userPrivilegeInfo;
  }
  getUserPrivilegeInfo() {
    console.log('Data Service :: sending user privilege info ', this.userPrivilegeInfo)
    return this.userPrivilegeInfo;
  }

  setFCConnectionKey(fcConnectionKey: string) {
    this.fcConnectionKey = fcConnectionKey;
  }
  getFCConnectionKey() {
    return this.fcConnectionKey;
  }

  setFilesToUpload(filesToUpload: string[]) {

    this.filesToUpload = filesToUpload;

  }

  pushToFilesToUpload(filesToUpload: string[]) {
    if (filesToUpload != undefined && filesToUpload.length > 0) {
      filesToUpload.forEach((fileName) => {
        if (this.filesToUpload.indexOf(fileName) < 0) {
          this.filesToUpload.push(fileName)
        }
      })
    }

  }

  getFilesToUpload(): string[] {
    return this.filesToUpload;
  }

  removeFromFilesToUpload(index: number) {
    console.log('removed ', this.filesToUpload.splice(index, 1).toString())
    // this.filesToUpload.splice(index,1);
  }

  setUploadFiles(uploadFiles: UploadStatusModel[]) {
    this.uploadFiles = uploadFiles;
  }

  getUploadFiles() {
    return this.uploadFiles;
  }

  addToUploadFiles(uploadFile: UploadStatusModel) {

    console.log('in add to upload files method ',uploadFile)
    if (this.uploadFiles.length > 0) {

      let existingRec:UploadStatusModel[] = this.uploadFiles.filter((value) => value.fileName == uploadFile.fileName);

      if(existingRec.length > 0){
        let result = window.confirm('A Transfer Record Already exists for '+uploadFile.fileName+', do you want to overwrite the record?, click cancel to skip this record');
        if(result){
          this.uploadFiles.filter((value,index) => {if(value.fileName == uploadFile.fileName){
            console.log('removing ',value,' at index ',index)
            this.uploadFiles.splice(index,1)}});
          console.log('pushing uploadFile ',uploadFile)
          this.uploadFiles.push(uploadFile);
        }
      }else{
        console.log('Adding to uploadFiles ',uploadFile)
      this.uploadFiles.push(uploadFile);
      }
    } else {
      console.log('Adding to uploadFiles ',uploadFile)
      this.uploadFiles.push(uploadFile);
    }
    console.log('upload files ',this.uploadFiles)
  }

  setToggleValue(toggleValue: boolean) {
    this.toggleValue = toggleValue;
  }

  getToggleValue() {
    return this.toggleValue;
  }

  pushToAgileFileInfo(uploadFileInfo: AgileFileInfo) {
    this.uploadFileInfo.push(uploadFileInfo);
  }
  getAgileFileInfo(): AgileFileInfo[] {
    return this.uploadFileInfo;
  }
  setAgileFileInfo(uploadFileInfo: AgileFileInfo[]) {
    console.log('setting file Info in getAgileFileInfo ', uploadFileInfo)
    this.uploadFileInfo = uploadFileInfo;
  }

  addToAgileFileInfo(uploadFileInfo:AgileFileInfo){
    if(this.uploadFileInfo != undefined && this.uploadFileInfo.length >0){
      if(this.uploadFileInfo.filter((value) => {if(value.fileName == uploadFileInfo.fileName){return value;}}).length==0)
      {
        this.uploadFileInfo.push(uploadFileInfo);
      }

    }
    else{
      this.uploadFileInfo.push(uploadFileInfo);
    }
  }
  getAgileFileInfoForFile(fileName: string): AgileFileInfo {

    console.log('Upload file Info in getAgileFileInfo ', this.uploadFileInfo)
    let agileFileInfo: AgileFileInfo;
    this.uploadFileInfo.forEach((value) => {
      if (value.fileName == fileName) {
        console.log('setting value of Agile file info in data service ', value)
        agileFileInfo = value;
      }
    })
    console.log('agileFileInfo ', agileFileInfo)
    return agileFileInfo;
    // return this.uploadFileInfo.filter((value) => value.fileName = fileName)[0];
  }

  getAgileFileDownloadRequests() {
    console.log('File Download Request ',this.agileFileDownloadReqs)
    return this.agileFileDownloadReqs;
  }
  setAgileFileDownloadRequests(agileFileDownloadReqs: AgileFileDownloadRequest) {
    this.agileFileDownloadReqs = agileFileDownloadReqs;
  }



  getDownloadFilesInfo() {
    return this.downloadFilesInfo;
  }
  setDownloadFilesInfo(downloadFilesInfo: DownloadStatusModel[]) {
    if (this.downloadFilesInfo.length == 0) {
      this.downloadFilesInfo = downloadFilesInfo;
    } else {
      this.downloadFilesInfo.forEach((downloadFile) => {
        downloadFilesInfo.forEach((ipDownloadFile, index) => {
          if (downloadFile.fileName == ipDownloadFile.fileName) {
            // need to handled the reprocess of Agile, if the status is complete, splice it, else, no
            downloadFilesInfo.splice(index, 1);
          }
        })
      })

      // for the remaining input downloads
      if (downloadFilesInfo.length > 0) {
        downloadFilesInfo.forEach((downloadFile) => {
          this.downloadFilesInfo.push(downloadFile);
        })
      }
    }
    console.log('Download Files Info in Dataservice ', this.downloadFilesInfo)
  }

  addToDownloadFiles(downloadFile:DownloadStatusModel){
    console.log('in add to upload files method ',downloadFile)
    if (this.downloadFilesInfo.length > 0) {

      let existingRec:DownloadStatusModel[] = this.downloadFilesInfo.filter((value) => value.fileName == downloadFile.fileName);

      if(existingRec.length > 0){
          this.downloadFilesInfo.filter((value,index) => {if(value.fileName == downloadFile.fileName){
            console.log('removing ',value,' at index ',index)
            this.downloadFilesInfo.splice(index,1)}});
          console.log('pushing uploadFile ',downloadFile)
          this.downloadFilesInfo.push(downloadFile);
      }else {
        console.log('Adding to Download Files ',downloadFile)
        this.downloadFilesInfo.push(downloadFile);
      }
    } else {
      console.log('Adding to Download Files ',downloadFile)
      this.downloadFilesInfo.push(downloadFile);
    }
    console.log('Download files ',this.downloadFilesInfo)
  }



  getFileTypeCodeRes() {
    this.agileService.getFileTypeCodesDropDown().subscribe(
      (data) => {
        this.fileTypeCodeRes = data;
        if(this.urlParams.partRevision.startsWith('A')){
          console.log('A revision')
          this.fileTypeCodeRes = this.fileTypeCodeRes.filter((value) => value.allowedForArev)
          console.log('A rev File Type Codes ',this.fileTypeCodeRes);
        }
        console.log("File Type Code ", this.fileTypeCodeRes);
      })
  }

  getDigitalSign(fileTypeCode: string): any[] {
    //this.t.at(index).get('fileNameWithPath').setValue("");
    console.log("Data Service Digital Sign ", fileTypeCode)
    if (fileTypeCode != "") {
      console.log("File Type Code ", fileTypeCode)
      let localFileTypeRes = [];
      localFileTypeRes = this.fileTypeCodeRes.filter(a => (a.fileTypeCode === fileTypeCode));
      console.log("File Type Res ", localFileTypeRes);
      return localFileTypeRes;
    }


  }

  getFileTypeCodeDetails(fileTypeCode: string): FileTypeCodeInfo {
    if (this.fileTypeCodeRes != undefined && this.fileTypeCodeRes.length > 0) {
      return this.fileTypeCodeRes.filter((value) => {
        if (value.fileTypeCode == fileTypeCode) {
          return value;
        }
      })[0]
    }
  }

  getFileTypeCodes(): FileTypeCodeInfo[] {
    return this.fileTypeCodeRes;
  }

  getArevFileTypeCodes():string[]{
    let aRevFileTypeCodes:string[] = [];
    if(this.fileTypeCodeRes != undefined){
      this.fileTypeCodeRes.forEach((value) => {
        if(value.allowedForArev){
          aRevFileTypeCodes.push(value.fileTypeCode);
        }
      })
    }
    return aRevFileTypeCodes;
  }

  setPartAttachments(partAttachment: PartAttachmentInfo[]): void {
    this.partAttachments = partAttachment;
  }

  setUploadPGPMessage(pgpMessage: string): void {
    this.uploadPGPMessage = pgpMessage;
  }

  getUploadPGPMessage(): string {
    return this.uploadPGPMessage;
  }
  
  setDownloadPGPMessage(pgpMessage: string): void {
    this.downloadPGPMessage = pgpMessage;
  }

  getDownloadPGPMessage(): string {
    return this.downloadPGPMessage;
  }

  getPartAttachments(): PartAttachmentInfo[] {
    return this.partAttachments;
  }

  setHardwareRelInfo(hardwareRelInfo:HardwareRelationshipMappingInfo)
  {
    this.hardwareRelationshipInfo = hardwareRelInfo;
  }

  getHardwareRelInfo(){
    return this.hardwareRelationshipInfo;
  }

  setTransferRequests(transferRequests:TransferFilesRequestModel[]){
    this.transferRequests = transferRequests;
  }

  getTransferRequests():TransferFilesRequestModel[]{

    return this.transferRequests;
  }

  addToTransferRequest(transferRequest:TransferFilesRequestModel){
    this.transferRequests.push(transferRequest);
  }


}
